(function () {
  const KLAVIYO_API_KEY = 'UwPY6v';
  const KLAVIYO_LIST_ID = 'TUvyfp';
  const API_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_API_KEY;

  function initNotifyMe() {
    document.querySelectorAll('.klaviyo-notify-me').forEach(function (container) {
      const form = container.querySelector('.klaviyo-notify-me__form');
      if (!form || form.dataset.initialized) return;
      form.dataset.initialized = 'true';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        handleSubmit(container);
      });
    });
  }

  function handleSubmit(container) {
    const form = container.querySelector('.klaviyo-notify-me__form');
    const input = container.querySelector('.klaviyo-notify-me__input');
    const errorEl = container.querySelector('.klaviyo-notify-me__error');
    const buttonText = container.querySelector('.klaviyo-notify-me__button-text');
    const buttonLoading = container.querySelector('.klaviyo-notify-me__button-loading');
    const successEl = container.querySelector('.klaviyo-notify-me__success');
    const email = input.value.trim();

    errorEl.textContent = '';

    if (!email || !isValidEmail(email)) {
      errorEl.textContent = 'Please enter a valid email address';
      input.focus();
      return;
    }

    buttonText.style.display = 'none';
    buttonLoading.style.display = '';

    const variantId = container.dataset.variantId;

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (response.ok || response.status === 202) {
          form.style.display = 'none';
          successEl.style.display = '';
        } else {
          return response.json().then(function (data) {
            throw new Error(data.errors?.[0]?.detail || 'Something went wrong. Please try again.');
          });
        }
      })
      .catch(function (err) {
        errorEl.textContent = err.message || 'Something went wrong. Please try again.';
      })
      .finally(function () {
        buttonText.style.display = '';
        buttonLoading.style.display = 'none';
      });
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // Listen for variant changes to show/hide the form
  function handleVariantChange() {
    document.addEventListener('change', function (e) {
      // Variant changes are handled by product-info.js which updates the DOM
      // We observe the ATC button state to toggle notify me visibility
    });

    // Use MutationObserver on ATC buttons to detect sold-out state changes
    document.querySelectorAll('[id^="ProductSubmitButton-"]').forEach(function (btn) {
      const sectionId = btn.id.replace('ProductSubmitButton-', '');
      const notifyContainer = document.getElementById('KlaviyoNotifyMe-' + sectionId);
      if (!notifyContainer) return;

      const observer = new MutationObserver(function () {
        const isSoldOut = btn.disabled && btn.querySelector('span')?.textContent.trim().toLowerCase().includes('sold out');
        notifyContainer.style.display = isSoldOut ? '' : 'none';

        // Reset form when showing
        if (isSoldOut) {
          const form = notifyContainer.querySelector('.klaviyo-notify-me__form');
          const success = notifyContainer.querySelector('.klaviyo-notify-me__success');
          if (form) form.style.display = '';
          if (success) success.style.display = 'none';
        }
      });

      observer.observe(btn, { attributes: true, childList: true, subtree: true });
    });
  }

  // Also update variant ID when variant changes
  function observeVariantIdChanges() {
    document.querySelectorAll('.klaviyo-notify-me').forEach(function (container) {
      const sectionId = container.dataset.sectionId;
      const hiddenInput = document.querySelector('#ProductSubmitButton-' + sectionId)
        ?.closest('form')
        ?.querySelector('input[name="id"]');

      if (!hiddenInput) return;

      const observer = new MutationObserver(function () {
        container.dataset.variantId = hiddenInput.value;
      });

      observer.observe(hiddenInput, { attributes: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initNotifyMe();
      handleVariantChange();
      observeVariantIdChanges();
    });
  } else {
    initNotifyMe();
    handleVariantChange();
    observeVariantIdChanges();
  }
})();
